import { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Template } from './Template';

function RunCampaignWCA() {
  const toast = useRef(null);
  return (
    <>
      <Toast ref={toast} />
      <Template toast={toast} />
    </>
  );
}

export default RunCampaignWCA;
